import { render, staticRenderFns } from "./SpotHealth.global.vue?vue&type=template&id=c143048a&lang=pug&"
import script from "./SpotHealth.global.vue?vue&type=script&lang=ts&"
export * from "./SpotHealth.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports